// @flow
import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import i18n from 'app/common/i18n';
import { setTitle } from 'app/layout/redux';
import GraphConnectionTable from './table';

import RowDetail from './table/RowDetail';

type Props = {
  setTitle: (title?: string) => void,
  i18n: (value: string) => string,
  params?: {
    uuid?: string
  }
};

const USERS = `
  query UserConnection($query: UserQueryInput, $filter: UserFilterInput!, $sortBy: UserSortByOption, $sortDir: ConnectionSortDir, $before: String, $after: String, $first: Int, $last: Int) {
  userConnection(query: $query, filter: $filter, sortBy: $sortBy, sortDir: $sortDir, before: $before, after: $after, first: $first, last: $last) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        id
        name
        email
        phone
      }
    }
  }
}
`;

@connect(() => ({}), { setTitle })
@i18n
class Users extends Component<Props, {}> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.setTitle(this.props.i18n('Users'));
  }

  componentWillUnmount() {
    this.props.setTitle();
  }

  render() {
    const uuid = this.props.params && this.props.params.uuid;

    return (
      <div>
        <GraphConnectionTable
          query={USERS}
          connectionName="userConnection"
          defaultVariables={
            uuid ? { query: { id: uuid } } : { sortBy: 'CREATED_AT' }
          }
          RowDetail={RowDetail}
          columnData={[
            {
              id: 'name',
              label: 'Name',
              filter: true
            },
            {
              id: 'email',
              label: 'Email',
              filter: true
            },
            {
              id: 'phone',
              label: 'Phone',
              filter: true
            }
          ]}
          i18n={(...args) => this.props.i18n(...args)}
        />
      </div>
    );
  }
}

function UsersWithRouter(props) {
  const params = useParams();

  return <Users {...props} params={params} />;
}

export default UsersWithRouter;